import { FunctionComponent } from 'react';
import FursysWrapper from './fursys.style';
import FursysTop from '@component/FursysTop';
import FursysFooter from '@component/FursysFooter';
import FursysInquiryButton from '@component/FursysInquiryButton';
import FursysBenefit1 from '@component/FursysBenefit1';
import FursysBenefit2 from '@component/FursysBenefit2';
import HeadMetaTag from '@component/HeadMetaTags';
import { getStaticImageUrl } from '@utils/createImageUrl';

const FursysPage: FunctionComponent = () => {
  const title = '퍼시스 X 로톡';
  const description = '변호사님께 드리는 특별한 혜택을 알아보세요.';
  const metaImage = `${getStaticImageUrl({ fileName: 'fursys_metaimage.png' })}`;
  return (
    <FursysWrapper>
      <HeadMetaTag title={title} description={description} image={metaImage} />
      <FursysInquiryButton />
      <div className="fursys-top">
        <FursysTop />
      </div>
      <div className="fursys-main">
        <FursysBenefit1 />
        <FursysBenefit2 />
      </div>
      <div className="fursys-footer">
        <FursysFooter />
      </div>
    </FursysWrapper>
  );
};

export default FursysPage;
